import React from 'react';
import styled from 'styled-components';
import SparklinesLine from './SparklinesLine';
import SparklinesSpots from './SparklinesSpots';
import TimeLine from './TimeLine'; // inspiration from github.com/borisyankov/react-sparklines with lot of modifications

// Scale the graphic content of the given element non-uniformly if necessary such that the element's bounding box exactly matches the viewport rectangle.
// preserveAspectRatio: 'none', https://www.w3.org/TR/SVG/coords.html#PreserveAspectRatioAttribute
const SparklinesDiv = styled.div.withConfig({
  displayName: "SparkLine__SparklinesDiv",
  componentId: "bl9nax-0"
})(["display:flex;flex-grow:1;flex-shrink:1;flex-basis:fit-content;flex-direction:column;"]);

const Sparklines = ({
  width = 250,
  height = 60,
  // margin of 25 for the start/end text room
  margin = 30,
  style,
  preserveAspectRatio = 'none',
  limit,
  dates,
  children
}) => {
  // The viewBox attribute defines the position and dimension, in user space, of an SVG viewport.
  // viewBox attribute is a list of four numbers: min-x, min-y, width and height.
  const svgOpts = {
    style,
    viewBox: `0 0 ${width} ${height}`,
    preserveAspectRatio,
    width,
    height
  };
  return /*#__PURE__*/React.createElement(SparklinesDiv, null, /*#__PURE__*/React.createElement("svg", svgOpts, React.Children.map(children, function (child) {
    return /*#__PURE__*/React.cloneElement(child, {
      width,
      height,
      margin,
      limit
    });
  })), dates && /*#__PURE__*/React.createElement(TimeLine, {
    dates: dates,
    width: width
  }));
};

export { Sparklines, SparklinesLine, SparklinesSpots };